interface GetCoverSheetPayloadType {
  ProcedureId: string;
  ProcedureTaskId: string;
}

enum ShowType {
  NA,
  Archived,
  ShowChanges,
}

enum FileOperate {
  Added = 1,
  Replaced,
  Deleted,
}

enum ProcedureSavedInChangeType {
  None,
  "Procedure Saved In changed to: PMP System Only",
  "Procedure Saved In changed to: PMP System & Client Server",
  "Procedure Saved In changed to: Client Server Only",
  "Procedure Saved In changed to N/A",
}

interface GetCoverSheetResponseType {
  taskInfo: {
    accountName: string;
    accountAbbr: string;
    accountManager: string;
    accountLocation: string;
    accountTeamLeader: string;
    accountSupervisor: string;
    taskLabelName: string;
    taskId: number;
    turnaroundTime: string;
    highRegulatedName: string;
  };
  procedureInfo: {
    primaryProcedureOwner: string;
    procedureOwner: string;
    initiator: string;
    createdTimeString: string;
    procedureStatus: string;
  };
  shareTaskInfos: {
    accountCode: string;
    taskId: number;
    taskLabelName: string;
  }[];
  changeHistories: {
    approvalDate: string;
    revisionCategory: string;
    changes: {
      fileName: string;
      fileOperate: FileOperate;
    }[];
    approvedBy: string;
    showType: ShowType;
    procedureSavedInChangeType: ProcedureSavedInChangeType;
    isClientServerPathChange: boolean;
  }[];
}

type GetAccountAbbrListResponseType = {
  accountAbbr: string;
  accountId: number;
}[];

interface SortItems {
  amIds: any[];
  asIds: any[];
  tlIds: any[];
  taskLabelNames: any[];
  taskIds: any[];
  procedureFolderStatusIds: any[];
  isHighlyRegulated: null;
  isTemporaryTask: null;
  isSharedTask: null;
  isPmpExcluded: null;
  procedureStatusIds: any[];
  procedureSaveInCategoryIds: any[];
  ppoIds: any[];
  poIds: any[];
}

interface GetProcedureListNewPayloadType extends SortItems {
  pageIndex: number;
  pageSize: number;

  accountStatus?: number;
  taskStatus?: number;
  accountIds: number[];
  taskGroupIds: number[];
  categoryIds: number[];

  taskLabelName: string;
  taskId: string;

  orderByAsc: boolean;
  orderBy: null;
}

interface GetProcedureListNewResponseType {
  totalRecord: number;
  totalPage: number;
  newData: {
    clientAbbr: string;
    clientName: string;
    accountAbbr: string;
    accountName: string;
    accountManager: string;
    accountSupervisor: string;
    accountTeamLeader: string;
    taskStatus: boolean;
    taskGroupName: string;
    categoryName: string;
    taskLabelName: string;
    taskId: number;
    taskCreatedTime: string;
    highRegulated: boolean;
    turnaroundTime: string;
    temporaryTask: boolean;
    isSharedTask: boolean;
    pmpExcluded: boolean;
    sharedTaskIds: null;
    sharedTaskNames: null;
    procedureStatus: string;
    procedureSaveInCategory: null;
    clientServerPath: null;
    primaryProcedureOwner: string;
    primaryProcedureOwnerName: string;
    ppoEditable: boolean;
    ppoMessage: 0 | 1 | 2;
    procedureOwner: string;
    procedureFolderCreateTime: null;
    lastUpdatedTime: null;
    procedureFolderStatus: string;
    //没有用到
    procedureAccountID: string;
    accountID: number;
    accountStatus: boolean;
    isMainTask: boolean;
    procedureOwnerName: string;
    procedureTaskId: string;
    procedureId: string;
    mainTaskId: number;
    pendingEditPPO: boolean;
  }[];
}

interface GetProcedureListFilterNewResponseType {
  accountManagers: {
    id: string;
    name: string;
  }[];
  accountSupervisors: {
    id: string;
    name: string;
  }[];
  accountTeamLeaders: {
    id: string;
    name: string;
  }[];
  taskLabelNames: string[];
  taskIds: number[];
  procedureFolderStatus: {
    id: string;
    name: string;
  }[];
  isHighRegulated: number[];
  isTemporaryTask: number[];
  isSharedTask: number[];
  sharedTasks: {
    sharedTaskIds: string;
    sharedTaskNames: string;
    taskIds: number[];
    taskLabelName: string;
    isMainTask: boolean;
  }[];
  procedureStatus: {
    id: string;
    name: string;
  }[];
  isPmpExcluded: number[];
  procedureSaveInCategory: {
    id: string;
    name: string;
  }[];
  primaryProcedureOwner: {
    id: string;
    name: string;
  }[];
  procedureOwner: {
    id: string;
    name: string;
  }[];
}

type GetGlobalFiltersResponseType = {
  accountAbbr: string;
  accountId: number;
  taskGroups: {
    taskGroupName: string;
    taskGroupId: number;
    categories: {
      categoryId: number;
      path: string;
    }[];
  }[];
}[];

interface ICheckSectionLockPayload {
  procedureId: string;
  procedureSectionType: string;
  timeOutMins: number;
}

interface IChangeSectionLockPayload {
  procedureId: string;
  procedureSectionType: string;
  setLock: boolean;
  timeOutMins?: number;
}

interface ISectionLockResponse {
  data: {
    isLocked: boolean;
    lockUser: string;
  };
  statusCode: number;
  message: string;
  succeeded: boolean;
}

interface IGetTaskProcedurePPOInfoResponse {
  primaryProcedureOwnerID: null | string;
  procedureID: string | null;
  taskStatus: boolean;
}

export type {
  GetAccountAbbrListResponseType,
  GetCoverSheetPayloadType,
  GetCoverSheetResponseType,
  GetProcedureListNewPayloadType,
  GetProcedureListNewResponseType,
  GetProcedureListFilterNewResponseType,
  SortItems,
  GetGlobalFiltersResponseType,
  ICheckSectionLockPayload,
  ISectionLockResponse,
  IChangeSectionLockPayload,
  IGetTaskProcedurePPOInfoResponse,
};
export { ShowType, FileOperate, ProcedureSavedInChangeType };
